import WORKOUT_SECTIONS_DOMAIN from './domain'
import WORKOUT_SECTIONS_KEY from './key'

const WORKOUT_SECTIONS_PATH = {
  ALL: `${WORKOUT_SECTIONS_DOMAIN}.${WORKOUT_SECTIONS_KEY.ALL}`,
  ALL_DATA: `${WORKOUT_SECTIONS_DOMAIN}.${WORKOUT_SECTIONS_KEY.ALL}.data`,
  CURRENT: `${WORKOUT_SECTIONS_DOMAIN}.${WORKOUT_SECTIONS_KEY.CURRENT}`,
  DATA: `${WORKOUT_SECTIONS_DOMAIN}.${WORKOUT_SECTIONS_KEY.DATA}`
}

export default WORKOUT_SECTIONS_PATH
